import { PrefetchContext } from '$templates/pages/utils/prefetch-data';
import { createTranslationQueryOptionsForServer } from '../hooks/use-translation';

export async function translationPrefetch({ page, httpHeaders, queryClient }: PrefetchContext) {
    const queryOptions = createTranslationQueryOptionsForServer(page.culture, httpHeaders);
    await queryClient.prefetchQuery(...queryOptions);
}
